export enum Features {
  SAMOOBSLUGA = 'samoobsluga',
  ERRORS = 'errors',
  ROUTER = 'router',
  DANE_KLIENTA = 'daneKlienta',
  PRZEDMIOTY = 'przedmioty',
  PARAMETRY_KWOTY_DOCELOWEJ = 'parametryKwotyDocelowej',
  ZBIOR_USZKODZEN = 'zbiorUszkodzen',
  ZBIOR_USZKODZEN_PRZEDMIOTOW = 'zbiorUszkodzenPrzedmiotow',
  PARAMETRY_BIZNESOWE = 'parametryBiznesowe',
  HISTORIA_NAWIGACJI = 'historiaNawigacji',
  INFO = 'info',
  TOGGLES = 'toggles'
}
